class SearchView {
  _parentElement = document.querySelector('.search');

  getQuery() {
    const query = this._parentElement.querySelector('.search-field').value;
    this.#clearInput();
    return query;
  }

  #clearInput() {
    return (this._parentElement.querySelector('.search-field').value = '');
  }

  addHandlerSearch(handler) {
    this._parentElement.addEventListener('submit', function (e) {
      window.location.hash = '';
      e.preventDefault();
      handler();
    });
  }
}

export default new SearchView();
